module.exports = __webpack_public_path__ + "static/media/h.6ef9cbf7.gif";